import { useQuery } from '@tanstack/react-query';
import { getLeadSources } from '../api/leads';

export function useLeadSources(enabled = true) {
  return useQuery({
    queryKey: ['lead-sources'],
    queryFn: getLeadSources,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
